import { render } from "./popupPG.vue?vue&type=template&id=2cda74a7&scoped=true"
import script from "./popupPG.vue?vue&type=script&lang=js"
export * from "./popupPG.vue?vue&type=script&lang=js"

import "./popupPG.vue?vue&type=style&index=0&id=2cda74a7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mfeys\\Desktop\\HAv2\\actions\\18597-ocebio\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cda74a7"]])

export default __exports__